export const TIER1_REPORT_CHAT_KIND = 'tier1_report';

export function isTier1ReportChatMessage(msg) {
  if (!msg) return false;
  if (msg.messageKind === TIER1_REPORT_CHAT_KIND || msg.message_kind === TIER1_REPORT_CHAT_KIND) {
    return true;
  }
  if (msg.htmlUpdated) return true;
  const content = String(msg.content || '');
  return content.startsWith('[Report change]');
}

/**
 * Extract Tier 1 Report Q&A messages only — excludes main WRAITH operational chat.
 */
export function tier1ReportChatMessagesFromConversation(allMessages) {
  if (!Array.isArray(allMessages) || allMessages.length === 0) {
    return [];
  }

  return allMessages.filter(isTier1ReportChatMessage).map((msg) => ({
    role: msg.role === 'user' ? 'user' : 'assistant',
    content: String(msg.content || ''),
    timestamp: msg.timestamp || new Date().toISOString(),
    htmlUpdated: Boolean(msg.htmlUpdated),
    messageKind: TIER1_REPORT_CHAT_KIND,
  }));
}

/**
 * Merge Tier 1 Q&A turns back into a conversation message list.
 * Preserves welcome prefix and main chat; replaces report Q&A only.
 */
export function mergeTier1ReportChatIntoConversation(existingMessages, reportChatMessages) {
  const welcomePrefix = [];
  if (Array.isArray(existingMessages)) {
    for (const msg of existingMessages) {
      if (msg?.role === 'assistant') {
        welcomePrefix.push(msg);
      } else {
        break;
      }
    }
  }

  const afterWelcome = (existingMessages || []).slice(welcomePrefix.length);
  const mainChat = afterWelcome.filter((msg) => !isTier1ReportChatMessage(msg));

  const normalizedChat = (reportChatMessages || []).map((msg) => ({
    role: msg.role === 'user' ? 'user' : 'assistant',
    content: String(msg.content || ''),
    timestamp: msg.timestamp || new Date().toISOString(),
    message_kind: TIER1_REPORT_CHAT_KIND,
    ...(msg.htmlUpdated ? { htmlUpdated: true } : {}),
  }));

  return [...welcomePrefix, ...mainChat, ...normalizedChat];
}
